import ExpoIcon from '@/assets/icons/ic-nav-expo.svg';
import LoungeIcon from '@/assets/icons/ic-nav-lounge.svg';
import MainStageIcon from '@/assets/icons/ic-nav-main-stage.svg';
import PostersIcon from '@/assets/icons/ic-nav-posters.svg';
import ReceptionIcon from '@/assets/icons/ic-nav-reception.svg';
import ScheduleIcon from '@/assets/icons/ic-nav-schedule.svg';
import SessionsIcon from '@/assets/icons/ic-nav-sessions.svg';

export enum TabItemsLabels {
  eventMainStage = 'eventMainStage',
  eventSessions = 'eventSessions',
  eventPosters = 'eventPosters',
  eventReception = 'eventReception',
  eventLounge = 'eventLounge',
  eventSchedule = 'eventSchedule',
  eventExpo = 'eventExpo',
}

export enum TabItemsAnalyticsKey {
  mainStage = 'main_stage',
  sessions = 'sessions',
  posters = 'posters',
  reception = 'reception',
  lounge = 'lounge',
  schedule = 'schedule',
  expo = 'expo',
}

export const TAB_ITEMS = [
  {
    Icon: MainStageIcon,
    labelKey: TabItemsLabels.eventMainStage,
    analyticsKey: TabItemsAnalyticsKey.mainStage,
  },
  {
    Icon: SessionsIcon,
    labelKey: TabItemsLabels.eventSessions,
    analyticsKey: TabItemsAnalyticsKey.sessions,
  },
  {
    Icon: PostersIcon,
    labelKey: TabItemsLabels.eventPosters,
    analyticsKey: TabItemsAnalyticsKey.posters,
  },
  {
    Icon: ReceptionIcon,
    labelKey: TabItemsLabels.eventReception,
    analyticsKey: TabItemsAnalyticsKey.reception,
  },
  {
    Icon: LoungeIcon,
    labelKey: TabItemsLabels.eventLounge,
    analyticsKey: TabItemsAnalyticsKey.lounge,
  },
  {
    Icon: ScheduleIcon,
    labelKey: TabItemsLabels.eventSchedule,
    analyticsKey: TabItemsAnalyticsKey.schedule,
  },
  {
    Icon: ExpoIcon,
    labelKey: TabItemsLabels.eventExpo,
    analyticsKey: TabItemsAnalyticsKey.expo,
  },
];
